export default __webpack_public_path__ + "static/media/001-narrow.df856ac0.png";